export default "__VITE_ASSET__CVExwM1L__"